import { render, staticRenderFns } from "./OpinionPublishDetail.vue?vue&type=template&id=6d54004c&scoped=true&"
import script from "./OpinionPublishDetail.vue?vue&type=script&lang=js&"
export * from "./OpinionPublishDetail.vue?vue&type=script&lang=js&"
import style0 from "./OpinionPublishDetail.vue?vue&type=style&index=0&id=6d54004c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d54004c",
  null
  
)

export default component.exports